import Filter from '../Filter';
import Sort from '../Sort';
import {getPaginatedDataProviders} from '../../api/admin/DataProviderApi';

export default class DataProviderFilter extends Filter {
  constructor(data) {
    super(data);

    this.name = data?.name;
    this.status = data?.status;

    this.sorts = {
      name: data?.sorts?.name ?? new Sort(),
      status: data?.sorts?.status ?? new Sort(),
    }
  }

  get key() {
    return 'data-providers';
  }

  get paginatedFetcher() {
    return async () => await getPaginatedDataProviders(this);
  }
}